<template>
  <div class="bg-img">
    <div class="vcenter">
      <el-form class="login-form" ref="form" :model="form" status-icon :rules="rules" v-loading="loading"
        size="medium" @keyup.enter.native="submitForm('form')">
          <div>
            <label for="password">New Password:</label>
          </div>
        <el-form-item prop="password">
          <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
          <el-tooltip class="item" effect="dark" content="Password Requirements" placement="bottom">
            <el-button style="margin-left:5px" type="text" size="large" icon="custom-icon el-icon-info" @click="instructionPopup"></el-button>
          </el-tooltip>
        </el-form-item>
        <div><label for="confirmPassword">Confirm Password:</label></div>
        <el-form-item prop="confirmPassword">
          <el-input type="password" v-model="form.confirmPassword" placeholder="Confirm Password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" style="width:70%; margin-left:15%; font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="submitForm('form')">Submit</el-button>
        </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import HTTP_API from '@/utils/http-api'
import axios from 'axios'
export default {
  name: 'Login',
  data () {
    return {
      form: { password: '', confirmPassword: '', loginName: this.$route.query.loginName, passwordResetCode: this.$route.query.passwordResetCode},
			rules: {
				password: [{ required: true, message: 'Password is required' }],
				confirmPassword: [{ required: true, message: 'Confirm Password is required' }]
      },
      loading: false
    }
  },
  methods: {
    submitForm(formName) {
      var vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.loading = true
          HTTP_API.post('/account/resetPassword', this.form)
          .then(function (response) {
            console.log(response)
            vm.resetAllFlag()
            vm.$message.success({ message: 'Password is reset successfully.' })
            vm.$router.push({ name: 'login'})
          })
          .catch(function (error) {
            vm.resetAllFlag()
            vm.$message.error({ message: error.response.data, duration: 5000 })
          })
        } else {
          console.log('Validation failed')
          return false
        }
      })
    },
    resetAllFlag() {
      this.loading = false
    },
    validateResetLink() {
      console.log('Validating reset link')
      let url = '/account/resetPassword?loginName=' + this.form.loginName + '&passwordResetCode=' + this.form.passwordResetCode
        var vm = this
        vm.loading = true
        HTTP_API.get(url)
        .then(function (response) {
          console.log(response)
          vm.resetAllFlag()
        })
        .catch(function (error) {
          console.log(error)
          vm.resetAllFlag()
          vm.$message.error({ message: 'Unable to create/reset password.' })
          vm.$router.push({ name: 'login'})
        })
    },
    instructionPopup() {
      // this.$alert('<ul style="list-style-type:square"><li>Passwords must be at least 10 characters in length and maximum 25 characters.</li><li>Passwords must contain characters from at least three of the following four categories:</li><ul style="list-style-type:square"><li>English uppercase alphabet characters (A–Z).</li><li>English lowercase alphabet characters (a–z).</li> <li>Base 10 digits (0–9)</li><li>Non-alphanumeric characters (for example, !$#,%).</li><li>Last letter must not end with Non-alphanumeric characters (for example, !$#,%).</li><li>no whitespace allowed</li></ul></ul>',
      this.$alert('<ul style="list-style-type:square"><li>Passwords must be at least 10 characters in length and maximum 25 characters.</li>'
      + '<li>Passwords must contain characters from the following categories:</li>' +
      '<ul style="list-style-type:square"><li>English uppercase alphabet characters (A–Z).</li><li>English lowercase alphabet characters (a–z).</li> <li>Base 10 digits (0–9)</li><li>Non-alphanumeric characters (.,@#$%^&-+=!).</li></ul></ul>',
      'Hints', {dangerouslyUseHTMLString: true, closeOnClickModal:true});
    }
  },
  mounted(){
	this.validateResetLink()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .vcenter {
    position: absolute;
    margin: 0;
    top: 53%;
    left: 50%;
    -ms-transform: translate(-50%, -47%);
    transform: translate(-50%, -47%);
    width: 360px;
    color: #606266;
    background-color: #f2f2f2;
  }

  .login-form {
    border-radius: 5px;
    padding: 22px 22px;
    /* background: rgba(145, 121, 121, 0.9); */
    opacity: 0.96;
    box-shadow: 0 2px 6px 1px #666666;
  }

  div >>> .el-input{
    width: 275px;
  }

  div >>> .custom-icon {
    font-size: 1.5rem;
    color: rgb(32, 44, 76)
  }
</style>
